import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import WithCenter from '../layout/WithCenter';

function FourOhThree() {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(seconds - 1);
    }, 1000);
    if (seconds < 1) {
      navigate('/login');
    }
    return () => clearTimeout(timer);
  }, [seconds]);
  return (
    <WithCenter>
      <h1>403</h1>
      <p>{t('errors.forbidden')}</p>
      <Link to="/login">{t('go_to_login')}</Link>
      <p>
        <i>{t('redirect_to_login', { SECONDS: seconds })}</i>
      </p>
    </WithCenter>
  );
}

export default FourOhThree;
